import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HeatwaveDataService } from '../../side-bar/heat-watch/heatwave/heatwave-data.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-whatsapp-alert',
  templateUrl: './whatsapp-alert.component.html',
  styleUrls: ['./whatsapp-alert.component.scss']
})
export class WhatsappAlertComponent implements OnInit {

  mobileNumber: string = '';
  emailId: string = '';
  
  states: any[] = [];
  districts: any[] = [];
  blocks: any[] = [];

  selectedState: any = null;
  selectedDistrict: any = null;
  selectedBlock: any = null;

  constructor(
    public activeModal: NgbActiveModal,
    private heatwaveDataSrv: HeatwaveDataService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.fetchStates();
  }

  fetchStates() {
    this.heatwaveDataSrv.getAllChildLocationList('00cb31c7-2928-4e6d-adcc-443d478c90d6', 'COUNTRY', 'STATE').subscribe(data => {
      if (data) {
        this.states = data;
      }
    });
  }

  onStateChange() {
    this.districts = [];
    this.blocks = [];
    this.selectedDistrict = null;
    this.selectedBlock = null;
    if (this.selectedState) {
      this.heatwaveDataSrv.getAllChildLocationList(this.selectedState.lUUID, 'STATE', 'DISTRICT').subscribe(data => {
        if (data) {
          this.districts = data;
        }
      });
    }
  }

  onDistrictChange() {
    this.blocks = [];
    this.selectedBlock = null;
    if (this.selectedDistrict) {
      this.heatwaveDataSrv.getAllChildLocationList(this.selectedDistrict.lUUID, 'DISTRICT', 'BLOCK').subscribe(data => {
        if (data) {
          this.blocks = data;
        }
      });
    }
  }

  onSubmit() {
    if (!this.mobileNumber || !this.emailId || !this.selectedState || !this.selectedDistrict) {
      this.toastr.warning('Please fill all mandatory fields.');
      return;
    }

    const payload = {
      state_uuid: this.selectedState.lUUID,
      state_name: this.selectedState.ln,
      district_uuid: this.selectedDistrict.lUUID,
      district_name: this.selectedDistrict.ln,
      block_uuid: this.selectedBlock ? this.selectedBlock.lUUID : "",
      block_name: this.selectedBlock ? this.selectedBlock.ln : "",
      mobile_number: this.mobileNumber,
      email: this.emailId
    };

    this.heatwaveDataSrv.saveWhatsappAlert(payload).subscribe(res => {
      if (res && (res.status === 'SUCCESS' || res === 'SUCCESS' || res === 'User saved/updated successfully')) {
        this.toastr.success('Alert saved successfully');
        this.activeModal.close('Submit');
      } else {
        this.toastr.error('Something went wrong. Please try again.');
      }
    }, err => {
      this.toastr.error('Error occurred while saving alert.');
    });
  }

}
